import styled from 'styled-components';

import { IconButton } from '../../../../../../components';
import { ThemeProp } from '../../../../../../theme/Themes';

export const Container = styled.div`
  position: relative;
`;

export const StyledIconButton = styled(IconButton)`
  background: ${(props: ThemeProp) => props.theme.colors.layout.surface.default};
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 0.5rem;
  border: 1px solid ${(props: ThemeProp) => props.theme.colors.neutrals.c200};

  svg {
    path {
      stroke: ${(props: ThemeProp) => props.theme.colors.neutrals.c500};
    }
  }
`;

const COUNT_COMPONENT_SIZE = '0.875rem';

export const CountComponent = styled.div`
  position: absolute;
  top: -0.3125rem;
  right: -0.3125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${COUNT_COMPONENT_SIZE};
  height: ${COUNT_COMPONENT_SIZE};
  line-height: ${COUNT_COMPONENT_SIZE};
  padding-left: 0;
  font-size: 0.563rem; // NOTE: Design Specs
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.semibold};
  color: ${(props: ThemeProp) => props.theme.colors.layout.surface.default};
  background: ${(props: ThemeProp) => props.theme.colors.main.c600};
  border-radius: 50%;
`;
